import { Component, ElementRef, ViewChild, Inject, OnInit } from '@angular/core';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { FuseNavigationService } from '../../../core/components/navigation/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../core/services/config.service';
import { fuseAnimations } from '../../../core/animations';
import { NavigationModel } from '../../../navigation.model';
import { MatSnackBar } from '@angular/material';
import { LoginModel } from './Login.model';
import { InfoSesion } from '../Global/InfoSesion.model';
import { md5 } from '../Global/md5';
import { AuthService } from '../Seguridad/auth.service';
import { FormControl } from '@angular/forms';




var url = window.location.href;
var condition =  url.indexOf("victimas") == -1 ? true : false;



@Component({
	selector : 'sesiones',
	templateUrl : './sesiones.component.html',
	styleUrls  : [condition ? './login-2.component.scss':'./login-2.component2.scss'],
	animations : fuseAnimations
})


/**
* @author Camilo
* @since  08/11/2017
**/
export class sesionesComponent implements OnInit {
    sesionForm: FormGroup;
    sesionFormErrors: any;
    public datosLogin: LoginModel;
	public codigoConfirmacion: any;

    private timeInterval: any = undefined;
    public bloquearCampo: boolean = true;
    public bloquearCampoNormal: boolean = false;
	public cusuario: string = '';
	public cempresa: string = '';
	public cidsesion: string = '';
    public load: boolean = false;
    public mensajeTemporizador: string = 'HOLLAAA';

    public ocultar: boolean = false;
    public mensaje: string = "";

    constructor(
        private fuseConfig: FuseConfigService,
        private _serviciosGenerales: ServiciosGenerales,
        private router: Router,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
		private route: ActivatedRoute
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.sesionFormErrors = {
            codigoConfirmacion: {}
        };

        this.snackBar.dismiss();
    }

    ngOnInit() {
        this.inicializarForm(true);
		this.route.params.subscribe(params => {

			this.cusuario  = params['usuario'];
			this.cempresa  = params['empresa'];
			this.cidsesion = params['idsesion'];
		});
    }
    //                String expresionRegular="(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[! \" # $ % & ' ( ) * + , \\ -. / : ; < = > ? @ [ ] ^ _ ` { | }])(?=\\S+$).{14,30}";
    inicializarForm(generarSubcribe: boolean) {
        this.sesionForm = this.formBuilder.group({
            codigoConfirmacion: [{ disabled: this.bloquearCampo, value: this.codigoConfirmacion }, [Validators.required, Validators.maxLength(10)]]

        });
        if (generarSubcribe == true) {
            this.sesionForm.valueChanges.subscribe(() => {
                this.onsesionFormValuesChanged();
            });
        }

    }


    generarCodigo() {
        this.mensajeTemporizador = 'INICIA.. . ';
        let conteo = 300;
        this.load = true;

        this._serviciosGenerales.post("usuario/login/generar/codigo", { usuario: this.cusuario, clave: "", empresa: this.cempresa }).subscribe(res => {


            this.codigoConfirmacion = '';

            if (res.error == false) {

                this.bloquearCampoNormal = true;
                this.bloquearCampo = false;


                this.inicializarForm(false);

                this.timeInterval = setInterval(() => {
                    document.getElementById('codigoConfirmacion').focus();
                    conteo = conteo - 1;

                    document.getElementById("mensaje").innerHTML = ('Tiempo Restante: ' + conteo.toString());
                    if (conteo <= 0) {

                        document.getElementById("mensaje").innerHTML = ('El Tiempo ha vencido, por favor genere un nuevo código');

                        clearInterval(this.timeInterval);

                        this.load = false;
                        this.bloquearCampoNormal = false;
                        this.bloquearCampo = true;
                        this.inicializarForm(false);
                        this.codigoConfirmacion = '';

                        setTimeout(() => {
                            document.getElementById("empresa").focus();
                        }, 500)
                    }
                }, 1000);
            } else {
                this.load = false;
                this.bloquearCampoNormal = false;
                this.bloquearCampo = true;
                this.inicializarForm(false);
                this.codigoConfirmacion = '';
            }

            this.openSnackBar(res.mensaje, "X");

        }, error => {
            this.openSnackBarEspecial(error, "X");
            this.load = false;
            this.bloquearCampoNormal = false;
            this.bloquearCampo = true;
            this.inicializarForm(false);
            this.codigoConfirmacion = '';

        })
    }

    validarCodigo() {
        this._serviciosGenerales.post("usuario/login/validar/codigosesion",{ usuario: this.cusuario, clave: this.codigoConfirmacion, empresa: this.cempresa, idsesion: this.cidsesion }).subscribe(res => {
            if (res.error == false) {
                clearInterval(this.timeInterval);
                sessionStorage.removeItem('info');
                sessionStorage.removeItem('idsesion');
                this.router.navigate(['/login']);
            }
            this.openSnackBar(res.mensaje, "X");
        }, error => {
            this.openSnackBarEspecial(error, "X");
        })
    }


    onsesionFormValuesChanged() {
        for (const field in this.sesionFormErrors) {
            if (!this.sesionFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.sesionFormErrors[field] = {};

            // Get the control
            const control = this.sesionFormErrors[field];

            if (control && control.dirty && !control.valid) {
                this.sesionFormErrors[field] = control.errors;
            }
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 20000
        });
    }

    openSnackBarEspecial(message: string, action: string) {
        let snackBarRef = this.snackBar.open(message, action);

        snackBarRef.onAction().subscribe(() => {

            this.ocultar = false;
            this.mensaje = "";
        });

        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;

        if (shand.length != 0) {
            for (let i = 0; i < shand.length; i++) {
                shand[i].style.backgroundColor = "rgb(255 204 214)";
            }
        }
    }



}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Login/sesiones.component.ts